import { Injectable } from '@angular/core';
import { BridgeCommandsService } from '../../../bridge-commands.service';
import {
  Firestore,
  uid,
  WithRef,
  type DocumentReference,
} from '@principle-theorem/shared';
import {
  IDixelOpenPatientCommand,
  IDixelToDeviceCommand,
} from '@principle-theorem/principle-bridge-core';
import {
  IPatient,
  IBridgeDevice,
} from '@principle-theorem/principle-core/interfaces';

@Injectable()
export class IDixelFeatureService {
  constructor(private _bridgeCommands: BridgeCommandsService) {}

  async openPatient(
    patient: WithRef<IPatient>,
    deviceRef: DocumentReference<IBridgeDevice>
  ): Promise<void> {
    const updatedPatient = patient.metadata?.shortId
      ? patient
      : await this._assignPatientShortId(patient);

    const command: IDixelOpenPatientCommand = {
      type: IDixelToDeviceCommand.OpenPatient,
      data: { patient: updatedPatient },
    };
    await this._bridgeCommands.sendCommand(command, deviceRef);
  }

  private async _assignPatientShortId(
    patient: WithRef<IPatient>
  ): Promise<WithRef<IPatient>> {
    const shortId = uid();
    await Firestore.patchDoc(patient.ref, {
      metadata: {
        ...patient.metadata,
        shortId,
      },
    });

    return { ...patient, metadata: { ...patient.metadata, shortId } };
  }
}
